export type PostLoginHubMode = 'panel' | 'picker';

export type PostLoginRoute =
  | { kind: 'app_shell' }
  | { kind: 'post_login_hub'; mode: PostLoginHubMode }
  | { kind: 'branch_selector' };

export type ResolvePostLoginRouteInput = {
  /** Sucursales activas visibles para el usuario en la org actual. */
  activeBranchCount: number;
  /** Dueño de la org activa (`entitlements.is_owner`). */
  isOwner: boolean;
  /** Registro en `employees` (no dueño operando como empleado en otra org). */
  isEmployee: boolean;
  /** Acceso externo auditor/contador (organization_access_grants). */
  isGrant?: boolean;
  /** Sucursal ya elegida (persistida o auto-única). */
  currentBranchId: string | null | undefined;
};

/**
 * Decide la pantalla inicial post-login según el proto hub v2 (casos A–F + I).
 * Onboarding (G) se resuelve antes en AppNavigator / AccountSetup.
 */
export function resolvePostLoginRoute(input: ResolvePostLoginRouteInput): PostLoginRoute {
  const { activeBranchCount, isOwner, isEmployee, isGrant, currentBranchId } = input;

  if (currentBranchId) {
    return { kind: 'app_shell' };
  }

  if (activeBranchCount <= 0) {
    return { kind: 'branch_selector' };
  }

  if (activeBranchCount === 1) {
    return { kind: 'app_shell' };
  }

  if (isOwner) {
    return { kind: 'post_login_hub', mode: 'panel' };
  }

  if (isEmployee || isGrant) {
    return { kind: 'post_login_hub', mode: 'picker' };
  }

  return { kind: 'post_login_hub', mode: 'panel' };
}

export type InitialRootRouteName = 'AppShell' | 'PostLoginHub' | 'BranchSelector';

export function resolveInitialRootRouteName(input: ResolvePostLoginRouteInput): InitialRootRouteName {
  const route = resolvePostLoginRoute(input);
  if (route.kind === 'app_shell') {
    return 'AppShell';
  }
  if (route.kind === 'post_login_hub') {
    return 'PostLoginHub';
  }
  return 'BranchSelector';
}
